// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./../../../Git%20space/admin/standalone-hl7-viewer/src/app/app.component.scss"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,UAAA;ACAF","sourcesContent":["// Minimal styles for standalone app\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n","body {\n  margin: 0;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
